/**
 * Date picker calendar — wraps `react-day-picker` v9/v10 with project styling.
 * Used inside a Popover for date pickers ("Add event", etc.).
 */
import { DayPicker, type DayPickerProps } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { cn } from '@/lib/utils';

export type CalendarProps = DayPickerProps;

export function Calendar({ className, classNames, ...props }: CalendarProps) {
  return (
    <DayPicker
      className={cn('p-1', className)}
      classNames={{
        // Override the bundled CSS class names with project-tinted ones.
        // Keys are the v10 UI element names (lowercased).
        day: 'inline-flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium hover:bg-[color:var(--kz-color-brand-primary)]/10 hover:text-[color:var(--kz-color-brand-primary)]',
        day_button: 'inline-flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium',
        selected:
          'bg-[color:var(--kz-color-brand-primary)] text-white hover:bg-[color:var(--kz-color-brand-primary)] hover:text-white',
        today: 'ring-1 ring-[color:var(--kz-color-brand-primary)]/40 rounded-md',
        outside: 'text-[color:var(--kz-color-ink-muted)]/60',
        disabled: 'text-[color:var(--kz-color-ink-muted)]/40 cursor-not-allowed',
        caption_label: 'text-sm font-semibold',
        nav: 'flex items-center gap-1',
        button_previous:
          'inline-flex h-7 w-7 items-center justify-center rounded-md border border-[color:var(--kz-color-border-subtle)] bg-transparent text-[color:var(--kz-color-ink-secondary)] hover:bg-[color:var(--kz-color-surface-sunken)]',
        button_next:
          'inline-flex h-7 w-7 items-center justify-center rounded-md border border-[color:var(--kz-color-border-subtle)] bg-transparent text-[color:var(--kz-color-ink-secondary)] hover:bg-[color:var(--kz-color-surface-sunken)]',
        ...classNames,
      }}
      {...props}
    />
  );
}
